import kalkulatorVhkTemplate from './kalkulator-vhk.pug';
import {EMAIL_PATTERN, PHONE_PATTERN, SIMPLE_TEXT_PATTERN, NUMBER_PATTERN, MEMBERSHIP_PATTERN} from '../../../common/constants/consts';
import accessibleSelect from '../../../common/native-accessible-select/native-accessible-select';
export const KalkulatorVhkComponent = {
	template: kalkulatorVhkTemplate(),
	bindings: {
		id: '@',
		visszahivasIdok: '<',
		success: '<',
		onPostForm: '&'
	},
	controller: class KalkulatorVhkController {
		constructor($element, vcRecaptchaService) {
			'ngInject';
			this.$element = $element[0];
			this.vcRecaptchaService = vcRecaptchaService;
		}
		$onInit() {
			this.model = {};
			this.patterns = {
				email: EMAIL_PATTERN,
				phone: PHONE_PATTERN,
				simpleText: SIMPLE_TEXT_PATTERN,
				number: NUMBER_PATTERN,
				membership: MEMBERSHIP_PATTERN
			};
			setTimeout(() => {
				let selects = Array.from(this.$element.querySelectorAll('select'));
				selects.forEach(item => {
					setTimeout(() => {
						new accessibleSelect({ element: item });
					}, 0);
				});
			}, 0);

		}
		postContactForm() {
			if (this.visszahivasKeresForm.$valid) {
				this.onPostForm({
					data: this.model
				});
			}
		}
	}
}



// WEBPACK FOOTER //
// ../source/application/kalkulator/kalkulator-vhk/kalkulator-vhk.component.js